import { logError as report } from '~shared/observability/observability';

/**
 * Logs an error caught by the React error boundary.
 *
 * The console output is dev-only, and the report is unconditional: the
 * observability module constructs no exporter outside production and staging,
 * so locally this call is a no-op and the console is the only signal.
 *
 * @param error - The error to log
 * @param info - Additional information about the error, specifically the component stack
 */
export const logError = (
  error: Error,
  info: { componentStack?: string | null },
) => {
  if (import.meta.env.DEV) {
    console.log('Caught error:', error);
    console.log('Error details:', info);
  }

  report(error, {
    // Distinguishes this record from the global handler's copy of the same
    // error. It is part of the dedupe key, so the component stack below
    // survives regardless of which handler fires first.
    kind: 'react-boundary',
    'react.component_stack': info.componentStack ?? undefined,
  });
};
